import { DEVELOPMENT, PRODUCTION, RELEASE } from "./constants";

// This function will only use for modules that redirect to the Asuite
// TODO: will remove once Asuite becomes deprecated
export const hasModuleAccess = (key: string, list: any) => {
  if (list?.hasOwnProperty(key)) {
    return list[key];
  } else {
    return false;
  }
};

export const checkEnvironment = () => {
  let environment = DEVELOPMENT;
  if (process.env.REACT_APP_MSAL_REDIRECT_URI === "https://thehub.itx.com/") {
    environment = PRODUCTION;
  } else if (
    process.env.REACT_APP_MSAL_REDIRECT_URI ===
    "https://thehub-release.itx.dev/"
  ) {
    environment = RELEASE;
  }
  return environment;
};

export const checkUrlParam = (param: any | null) => {
  if (param !== "-1") {
    return param;
  } else {
    return null;
  }
};

// String parameter value has this format: (like "2025-9-30" or "2025-09-30")
export const isValidDateFormat = (str) => {
  if (!/^\d{4}-\d{1,2}-\d{1,2}$/.test(str)) return false;

  const [year, month, day] = str.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

export const getInitials = (name: string) => {
  let names = name.split(" "),
    initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};
